let timelineElements = [
	{
		id: 1,
		title: "Initialize Token",
		location: "September, 2021",
		description1: "• Launch Community Group ✅",
		description2: "• Launch Website ✅",
		description3: "• Launch Adazeus Token ✅",
		buttonText: "Success!",
		icon: "success",
	},
	{
		id: 2,
		title: "Marketing Phase",
		location: "September, 2021",
		description1: "• 10k Holders",
		description2: "• Further listings platforms",
		description3: "• Collaborations with key market players",
		buttonText: "Coming Soon!",
		icon: "cms",
	},
	{
		id: 3,
		title: "Retain Holder",
		location: "October, 2021",
		description1: "• Contract Logo",
		description2: "• Further Marketing",
		description3: "• Reach 20k Holders",
		description4: "• Reach 15k Telegram Members",
		buttonText: "Coming Soon!",
		icon: "cms",
	},
	{
		id: 4,
		buttonText: "Coming Soon!",
		end: "To be Announced!",
		icon: "cms",
	},
];

export default timelineElements;
